let lastHapticAt = 0;

const vibrate = (pattern: number | number[], minGapMs: number) => {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;

  const now = Date.now();
  if (now - lastHapticAt < minGapMs) return;
  lastHapticAt = now;

  try {
    navigator.vibrate(pattern);
  } catch {
    // Ignore browsers/devices without vibration support.
  }
};

export const Haptics = {
  tap: () => vibrate(10, 40),
  cut: () => vibrate([20, 30, 20], 120),
  turn: () => vibrate([12, 20, 20], 120),
  safe: () => vibrate([10, 20, 28], 120),
  win: () => vibrate([16, 24, 16, 24, 32], 200),
  lose: () => vibrate([36, 60, 36], 200),
};
